export default function Dictionaries() {
  return <>{/* <!--placeholder--> */}</>;
}
